export const GST_RATE_LIST = [
  {
    id: "0",
    value: "0%",
  },
  {
    id: "5",
    value: "5%",
  },
  {
    id: "18",
    value: "18%",
  },
  {
    id: "28",
    value: "28%",
  },
  {
    id: "40",
    value: "40%",
  }
];
